import script from "./WebAppIntegration.vue?vue&type=script&setup=true&lang=js"
export * from "./WebAppIntegration.vue?vue&type=script&setup=true&lang=js"

import "./WebAppIntegration.vue?vue&type=style&index=0&id=b3bb724c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3bb724c"]])

export default __exports__